import React, { useState } from "react";
import { Box, ButtonBase } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

// Video de YouTube enlazado en una noticia. Primero muestra solo la miniatura (una imagen liviana) y el reproductor
// de YouTube se carga recién al hacer clic, así un listado con varias noticias no carga varios reproductores a la vez.
export default function YoutubeEmbed({ videoId, sx }) {
  const [reproduciendo, setReproduciendo] = useState(false);
  if (!videoId) return null;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: "16 / 9",
        bgcolor: "common.black",
        borderRadius: 1,
        overflow: "hidden",
        ...sx,
      }}
    >
      {reproduciendo ? (
        <Box
          component="iframe"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title="Video de YouTube"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }}
        />
      ) : (
        <ButtonBase
          onClick={() => setReproduciendo(true)}
          aria-label="Reproducir video de YouTube"
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(https://i.ytimg.com/vi/${videoId}/hqdefault.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            "&:hover .yt-play, &:focus-visible .yt-play": { bgcolor: "#ff0000" },
          }}
        >
          <Box
            className="yt-play"
            sx={{
              width: 64,
              height: 44,
              borderRadius: 2.5,
              bgcolor: "rgba(0,0,0,0.7)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "background-color 0.15s ease",
            }}
          >
            <PlayArrowRoundedIcon sx={{ fontSize: 36 }} />
          </Box>
        </ButtonBase>
      )}
    </Box>
  );
}
